import { useEffect } from 'react';
import { useFormContext, useFieldArray } from 'react-hook-form';
import List from '@mui/material/List';
import ListItemText from '@mui/material/ListItemText';
import ListItem from '@mui/material/ListItem';
import Divider from '@mui/material/Divider';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import Stack from '@mui/material/Stack';
import Grid from '@mui/material/Grid';

import TextField from 'web/form/TextField';
import Select from 'web/form/Select';

const relationTypes = [
	{
		label: 'Meg selv',
		value: 'myself',
		restricted: true,
	},
	{ label: 'Familiemedlem', value: 'family' },
	{
		label: 'Nær forbindelse',
		value: 'closeConnection',
	},
];

export default function DynamicPEPFields({ name }) {
	const {
		control,
		formState: { defaultValues },
	} = useFormContext();

	const { fields, append, remove } = useFieldArray({
		control, // control props comes from useForm (optional: if you are using FormProvider)
		name, // unique name for your Field Array
	});

	const addField = () => {
		append({ type: '', name: '', address: '' });
	};

	const removeField = index => {
		remove(index);
	};

	useEffect(() => {
		if (fields?.length > 0) return;

		const defaultValuesForFieldArray = defaultValues[name];
		if (
			!defaultValuesForFieldArray ||
			defaultValuesForFieldArray.length === 0
		) {
			// If default values are not set, initialize with an empty array
			append({ type: '', name: '', address: '' });
		}
	}, [defaultValues, name]);

	return (
		<Stack spacing={2} sx={{ mt: 2, mb: 4 }}>
			<h3>Politiske Relasjoner</h3>

			<List sx={{ paddingTop: '0' }}>
				{fields?.map((field, index) => {
					return (
						<RelationItem
							key={field.id}
							name={name}
							index={index}
							handleDeleteRelation={removeField}
						/>
					);
				})}
			</List>

			<Button
				variant="outlined"
				color="primary"
				onClick={addField}
				endIcon={<AddIcon />}
				sx={{ alignSelf: 'flex-start' }}
			>
				Legg til relasjon
			</Button>
		</Stack>
	);
}

function RelationItem({ name, index, handleDeleteRelation }) {
	const { watch } = useFormContext();

	const typeName = `${name}.${index}.type`;
	const selectedType = watch(typeName);
	const restricted =
		relationTypes.find(rel => rel.value === selectedType)?.restricted ||
		false;

	return (
		<>
			<ListItem
				secondaryAction={
					<IconButton
						edge="end"
						onClick={() => handleDeleteRelation(index)}
					>
						<DeleteIcon />
					</IconButton>
				}
				sx={{ paddingLeft: '0' }}
			>
				<ListItemText>
					<Grid container spacing={2}>
						<Grid size={{ xs: 12, md: 4 }}>
							<Select
								size="large"
								name={typeName}
								label="Relasjon"
								options={relationTypes}
								sx={{ minWidth: '160px' }}
								fullWidth
								required
							/>
						</Grid>

						{!restricted && (
							<>
								<Grid size={{ xs: 12, md: 4 }}>
									<TextField
										label="Navn"
										name={`${name}.${index}.name`}
										size="large"
										required
										fullWidth
									/>
								</Grid>
								<Grid size={{ xs: 12, md: 4 }}>
									<TextField
										label="Adresse"
										name={`${name}.${index}.address`}
										size="large"
										required
										fullWidth
									/>
								</Grid>
							</>
						)}
					</Grid>
				</ListItemText>
			</ListItem>

			<Divider component="li" />
		</>
	);
}
